export interface Bonus {
  tag: string
  title: string
  value: string
  description: string
  image: string
}

export const bonuses: Bonus[] = [
  {
    tag: 'BONUS #1',
    title: '100 Prostho Flashcards™',
    value: '$29',
    description:
      '100 active-recall flashcards covering essential Prosthodontics concepts. Perfect for quick review sessions from your phone, tablet, or computer.',
    image: 'https://cdn.magicpatterns.com/uploads/nmbZBKyYFdvKr5oyfpm58C/BONUS_1_PROSTHO-EN.png',
  },
  {
    tag: 'BONUS #2',
    title: 'Prostho 7-Day Sprint™',
    value: '$27',
    description:
      'A 7-day review roadmap showing you what to focus on each day and how to structure your sessions before an exam.',
    image: 'https://cdn.magicpatterns.com/uploads/qjkLADRmjurN8TqQQDRTLc/BONUS_2_PROSTHO-EN.png',
  },
  {
    tag: 'BONUS #3',
    title: '"Don\'t Mix These Up" Library™',
    value: '$29',
    description:
      'A collection of visual side-by-side comparisons covering concepts, materials, techniques, and classifications students commonly confuse.',
    image: 'https://cdn.magicpatterns.com/uploads/fB9C6zbmGo7hDYXDdspCDh/BONUS_3_PROSTHO-EN.png',
  },
  {
    tag: 'BONUS #4',
    title: 'Prostho Exam Check™',
    value: '$19',
    description:
      'A self-assessment system designed to help you identify which concepts you can explain without your notes—and which ones still need work.',
    image: 'https://cdn.magicpatterns.com/uploads/1TqAwfKBnMskbrZw93o9qJ/BONUS_4_PROSTHO-EN.png',
  },
  {
    tag: 'BONUS #5',
    title: '30 Prostho Cheat Sheets™',
    value: '$29',
    description:
      'Quick-reference sheets featuring visual maps, tables, comparisons, and essential Prosthodontics concepts.',
    image: 'https://cdn.magicpatterns.com/uploads/t7y1Br6gNKQycVigncGSa6/BONUS_5_PROSTHO-EN.png',
  },
]
